// extracted by mini-css-extract-plugin
export var readonly = "_c2-1";
export var star = "_c2-0";